import { onScopeDispose } from 'vue';

import type { HotkeyRegistration } from './model';
import { createHotkeyRegistry, type HotkeyRegistry } from './registry';

let applicationRegistry: HotkeyRegistry | null = null;

const initHotkeys = (): void => {
  if (applicationRegistry === null) {
    applicationRegistry = createHotkeyRegistry(window);
  }
};

const getHotkeyRegistry = (): HotkeyRegistry => {
  if (applicationRegistry === null) {
    initHotkeys();
  }

  return applicationRegistry!;
};

const useHotkey = (
  registration: HotkeyRegistration,
  registry: HotkeyRegistry = getHotkeyRegistry(),
): void => {
  const unregister: () => void = registry.register(registration);

  onScopeDispose(unregister);
};

export { initHotkeys, useHotkey };
